import React, { Component } from 'react';
import './Svg.scss';
import './Icon.scss';

export default class LeaveIcon extends Component {
    render () {
        const { className, colorIndex, size } = this.props;
        let colorClass = 'color--' + colorIndex;
        let sizeClass = 'size--' + size;
        let finalClassName = "Icon " + className + " " + sizeClass + " " + colorClass;

        return (
        <svg className={finalClassName} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M11.8084 11.3673L16.0002 8.08586L11.8166 4.667C11.4901 4.40019 11.0002 4.63248 11.0002 5.05414L11 7.4954V5.99992L8 5.99992C6.89543 5.99992 6 6.89535 6 7.99992C6 9.10449 6.89543 9.99992 8 9.99992L11 9.99992L11 7.50516L11.0002 10.9736C11.0002 11.3904 11.4802 11.6242 11.8084 11.3673Z"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M5.2 4C4.64772 4 4.2 4.44772 4.2 5L4.2 11C4.2 11.5523 4.64772 12 5.2 12H7C8.10457 12 9 12.8954 9 14C9 15.1046 8.10457 16 7 16H4.2H3.5H3C1.89543 16 1 15.1046 1 14V2C1 0.895431 1.89543 0 3 0H3.5H4.2H7.4C8.28366 0 9 0.895431 9 2C9 3.10457 8.28366 4 7.4 4H5.2Z"/>
        </svg>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UIKit/Icon/Leave.js